module.exports = __webpack_public_path__ + "img/film_count.4f7890da.png";